// import Sequence from "../libs/deepstream/sequence";

const getDefaultState = () => {
  return {
    sequence: [],
    slide: 0
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    set(state, params) {
      state[params.path] = params.value;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    },
    sequence(state, sequence) {
      state.sequence = sequence;
    },
    slideUpdate(state, slide) {
      // increse/drecrease slide value
      if (slide === 1) {
        // next
        if (state.slide + 1 < state.sequence.length) state.slide++;
      } else if (slide === -1) {
        // previous
        if (state.slide - 1 >= 0) state.slide--;
      }
    }
  },
  getters: {
    get: state => path => {
      return state[path];
    },
    slide: state => {
      return state.slide;
    }
  },
  actions: {
    async set({ commit }, params) {
      commit("set", params);
    },
    getSequenceByID({ commit }, id) {
      fetch(`${process.env.API_BASE_URL}/sequences/by-id?session_id=${id}`)
        .then(response => response.json())
        .then(response => {
          commit("sequence", response);
        });
    }
  }
};
